var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('AppBase',{attrs:{"items":_vm.items}}):_c('Authentication')
}
var staticRenderFns = []

export { render, staticRenderFns }